import React from 'react';

const base = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

/** Hill fort / गड — crenellated walls and gate */
export function FortIcon({ className, ...props }) {
  return (
    <svg className={className} {...base} {...props} aria-hidden>
      <path d="M3 20h18" />
      <path d="M5 20V11l2-1v2l2-1v2l2-1v2l2-1v2l2-1v9" />
      <path d="M7 11V8l2-1.5 2 1.5v3" />
      <path d="M11 8V5l1-1.5 1 1.5v3" />
      <path d="M10 16h4" />
      <path d="M10 16v3M14 16v3" />
    </svg>
  );
}

/** Indian temple — shikhara, kalash, mandap */
export function TempleIcon({ className, ...props }) {
  return (
    <svg className={className} {...base} {...props} aria-hidden>
      <path d="M4 20h16" />
      <path d="M7 20V14c0-1.2 2.2-2 5-2s5 .8 5 2v6" />
      <path d="M12 4v1.5" />
      <circle cx="12" cy="3" r="0.75" fill="currentColor" stroke="none" />
      <path d="M12 5.5L9 11h6L12 5.5z" />
      <path d="M9 11c0 2 1.3 3 3 3s3-1 3-3" />
      <path d="M10 16h4" />
      <path d="M10 16v4M14 16v4" />
    </svg>
  );
}

/** Coastal sea fort — waves and bastion (Konkan routes) */
export function CoastalFortIcon({ className, ...props }) {
  return (
    <svg className={className} {...base} {...props} aria-hidden>
      <path d="M2 17h20" />
      <path d="M3 17c2-1.5 4-.5 6-2.5s4-2 6.5-.5 4.5 1.5 4.5 1.5" />
      <path d="M14 17V11l1.5-.9 1.5.9v1l1.5-.9V17" />
      <path d="M15 11V8.5l1-1 1 1V11" />
      <path d="M15.5 14h2" />
    </svg>
  );
}

/** Sahyadri hill range with fort on the crest */
export function SahyadriFortIcon({ className, ...props }) {
  return (
    <svg className={className} {...base} {...props} aria-hidden>
      <path d="M2 20h20" />
      <path d="M4 20l3-7 2.5 5L12 7l3.5 9L18 9l4 11" />
      <path d="M10.5 9.5h3v2h-3z" />
      <path d="M10 11.5h4" />
      <path d="M11 11.5V13M13 11.5V13" />
    </svg>
  );
}

/** Heritage gateway / torana (regional culture routes) */
export function HeritageMonumentIcon({ className, ...props }) {
  return (
    <svg className={className} {...base} {...props} aria-hidden>
      <path d="M4 20h16" />
      <path d="M6 20V11" />
      <path d="M18 20V11" />
      <path d="M6 11h12" />
      <path d="M8 11c0-3.5 1.8-6 4-6s4 2.5 4 6" />
      <path d="M12 4.5v2" />
      <circle cx="12" cy="3.5" r="0.8" fill="currentColor" stroke="none" />
      <path d="M9 16h6" />
    </svg>
  );
}

/** Hill-fort trek — ridge path to ramparts */
export function HillFortTrekIcon({ className, ...props }) {
  return (
    <svg className={className} {...base} {...props} aria-hidden>
      <path d="M3 20h18" />
      <path d="M5 20l4-9 3 6 4-11 5 14" />
      <path d="M13.5 7.5h3v2h-3z" />
      <path d="M13 9.5h4" />
      <path d="M5 20c1.5-3 3-5 5.5-6" />
      <circle cx="6" cy="13.5" r="0.65" fill="currentColor" stroke="none" />
      <circle cx="8" cy="15.5" r="0.65" fill="currentColor" stroke="none" />
      <path d="M17 5l1.5 1.5L17 8" />
    </svg>
  );
}

/** Palace / wada — arched facade with chhatri */
export function PalaceIcon({ className, ...props }) {
  return (
    <svg className={className} {...base} {...props} aria-hidden>
      <path d="M3 20h18" />
      <path d="M5 20V13" />
      <path d="M19 20V13" />
      <path d="M5 13h14" />
      <path d="M8 13c0-2.8 1.8-5 4-5s4 2.2 4 5" />
      <path d="M12 8v2" />
      <circle cx="12" cy="7" r="0.75" fill="currentColor" stroke="none" />
      <path d="M8 16h8" />
      <path d="M8 16v4M16 16v4" />
      <path d="M10 13h4v3" />
    </svg>
  );
}

/** Battlefield — crossed swords */
export function BattlefieldIcon({ className, ...props }) {
  return (
    <svg className={className} {...base} {...props} aria-hidden>
      <path d="M14.5 3 9 8.5" />
      <path d="M14.5 3l2 2-5.5 5.5" />
      <path d="M9.5 3 15 8.5" />
      <path d="M9.5 3l-2 2 5.5 5.5" />
      <path d="M12 11v10" />
      <path d="M10 21h4" />
    </svg>
  );
}

/** Historic scroll / chronicle */
export function ScrollEventIcon({ className, ...props }) {
  return (
    <svg className={className} {...base} {...props} aria-hidden>
      <path d="M8 4h8a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" />
      <path d="M8 6h8" />
      <path d="M9 10h6M9 14h6M9 18h4" />
      <path d="M6 8h1M6 12h1M6 16h1" />
    </svg>
  );
}

const HISTORIC_MAP_CATEGORY_ICONS = {
  fort: FortIcon,
  temple: TempleIcon,
  battlefield: BattlefieldIcon,
  palace: PalaceIcon,
  historic: HeritageMonumentIcon,
  event: ScrollEventIcon,
};

/** Sidebar / filter chip icon for India historic map categories */
export function HistoricMapCategoryIcon({ category, className = 'h-4 w-4', ...props }) {
  const Icon = HISTORIC_MAP_CATEGORY_ICONS[category] || HeritageMonumentIcon;
  return <Icon className={className} {...props} />;
}

const MARKER_SVG_PATHS = {
  fort: '<path d="M3 20h18"/><path d="M5 20V11l2-1v2l2-1v2l2-1v2l2-1v2l2-1v9"/><path d="M7 11V8l2-1.5 2 1.5v3"/><path d="M11 8V5l1-1.5 1 1.5v3"/><path d="M10 16h4"/>',
  temple:
    '<path d="M4 20h16"/><path d="M7 20V14c0-1.2 2.2-2 5-2s5 .8 5 2v6"/><path d="M12 5.5 9 11h6z"/><path d="M9 11c0 2 1.3 3 3 3s3-1 3-3"/>',
  battlefield:
    '<path d="M14.5 3 9 8.5"/><path d="M14.5 3l2 2-5.5 5.5"/><path d="M9.5 3 15 8.5"/><path d="M9.5 3l-2 2 5.5 5.5"/><path d="M12 11v10"/>',
  palace:
    '<path d="M3 20h18"/><path d="M5 20V13"/><path d="M19 20V13"/><path d="M5 13h14"/><path d="M8 13c0-2.8 1.8-5 4-5s4 2.2 4 5"/><path d="M10 13h4v3"/>',
  historic:
    '<path d="M4 20h16"/><path d="M6 20V11"/><path d="M18 20V11"/><path d="M6 11h12"/><path d="M8 11c0-3.5 1.8-6 4-6s4 2.5 4 6"/>',
  event:
    '<path d="M8 4h8a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z"/><path d="M9 10h6M9 14h6"/>',
};

/** Inline SVG for Leaflet map markers (white stroke on colored pin) */
export function getHistoricCategoryMarkerSvg(category, size = 15) {
  const paths = MARKER_SVG_PATHS[category] || MARKER_SVG_PATHS.historic;
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${paths}</svg>`;
}

const THEMATIC_ROUTE_ICONS = {
  fort: FortIcon,
  coast: CoastalFortIcon,
  mountain: SahyadriFortIcon,
  temple: TempleIcon,
  heritage: HeritageMonumentIcon,
  trek: HillFortTrekIcon,
};

/** Icon for a thematic route by `icon` key from thematicRoutesMr */
export function ThematicRouteIcon({ type = 'fort', className, ...props }) {
  const Icon = THEMATIC_ROUTE_ICONS[type] || FortIcon;
  return <Icon className={className} {...props} />;
}
